import { FormControlLabel } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import BriaCheckbox from "../../../../../../components/common/BriaCheckbox/BriaCheckbox";
import BriaInput from "../../../../../../components/common/BriaInput/BriaInput";
import { APPS } from "../../../../../../constants/AppsConstants";
import { useSeedValidation } from "../../../../../../hooks/useSeedValidation";
import { useAppStore } from "../../../../../../hooks/useStores";
import InputLayout from "../../../../../../layout/InputLayout/InputLayout";

interface TextToImageSeedProps {
	hideDisplayToggle?: boolean;
}

const TextToImageSeed = ({ hideDisplayToggle = false }: TextToImageSeedProps) => {
	const { t } = useTranslation("translation", { keyPrefix: "playground.textToImage.config" });
	const { textToImageStore, playgroundStore } = useAppStore();
	const { config, handleConfigChange } = textToImageStore;

	const { handleSeedChange } = useSeedValidation({
		onSeedChange: (seed) => handleConfigChange("seed", seed),
	});

	useEffect(() => {
		handleConfigChange("displaySeed", playgroundStore.selectedConfig === APPS.TG_IMAGE_GENERATION);
	}, [playgroundStore.selectedConfig]);

	const handleDisplaySeedChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		handleConfigChange("displaySeed", e.target.checked);
	};

	return (
		<InputLayout label={t("seed.label")} info={t("seed.info")} optional>
			<BriaInput
				type="number"
				value={config?.seed}
				onChange={handleSeedChange}
				placeholder={t("seed.placeholder")}
				height="37px"
			/>
			{!hideDisplayToggle && (
				<FormControlLabel
					control={<BriaCheckbox checked={config?.displaySeed} onChange={handleDisplaySeedChange} />}
					label={t("seed.checkbox")}
				/>
			)}
		</InputLayout>
	);
};

export default observer(TextToImageSeed);
